module.exports = __webpack_public_path__ + "static/media/marmalade-logo.84b79aee.svg";